import {Grid} from '@material-ui/core';
import React, {useEffect} from 'react';

import {setHeaders} from '../../api/apis';
import {GUEST, X_CUSTOMER_ID, X_MERCHANT_ID} from '../../utils/constants';

import {PaymentButton} from './components/PaymentButton/PaymentButton';

export const CheckoutButtons: React.FC<CheckoutButtonProps> = (props) => {
  const {merchantId} = props;
  // const [currentCheckoutType, setCurrentCheckoutType] = useState<CurrentCheckoutType>(null);
  // const updateCurrentCheckoutType = (type: CurrentCheckoutType) => {
  //   setCurrentCheckoutType(type);
  // };

  useEffect(() => {
    setHeaders({
      [X_CUSTOMER_ID]: GUEST,
      [X_MERCHANT_ID]: merchantId,
    });
  }, []);

  return (
    <Grid container direction="column" justifyContent="center" style={{gap: '16px'}}>
      <Grid item container justifyContent="center" direction="column">
        <PaymentButton
          {...props}
          // currentCheckoutType={currentCheckoutType}
          // setCurrentCheckoutType={updateCurrentCheckoutType}
        >
          Text to Pay
        </PaymentButton>
      </Grid>
      {/* {shouldShowHealthSafePayButton ? (
        <>
          <Grid container alignItems="center">
            <Grid item style={{flexGrow: 1}}>
              <Divider variant="middle" />
            </Grid>
            <Typography>or</Typography>
            <Grid item style={{flexGrow: 1}}>
              <Divider variant="middle" />
            </Grid>
          </Grid>
          <Grid item container justifyContent="center" direction="column">
            <PaymentButton
              {...props}
              checkoutType="hsid"
              setCurrentCheckoutType={updateCurrentCheckoutType}
              currentCheckoutType={currentCheckoutType}
              buttonColor="secondary"
            >
              Login to Pay
            </PaymentButton>
          </Grid>
        </>
      ) : null} */}
    </Grid>
  );
};
